export const BROWSER = {
  mQ: num => window.matchMedia(`(max-width: ${num}px)`),

  isSafari: () => navigator.userAgent.indexOf('Safari') !== -1,

  isChrome: () => navigator.userAgent.indexOf('Chrome') !== -1,

  isExplorer: () =>
    navigator.appName == 'Microsoft Internet Explorer' ||
    !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)) ||
    navigator.userAgent.indexOf('MSIE') > -1,
    
  isFirefox: () => navigator.userAgent.indexOf('Firefox') > -1,

  handlePolyfill: () => {
    const body = document.querySelector('body')
    const polyfill = document.createElement('script')
    polyfill.src = 'https://cdnjs.cloudflare.com/ajax/libs/babel-core/5.6.15/browser-polyfill.min.js'
    polyfill.id = 'polyfill'
    body.appendChild(polyfill)
  },

  removePolyFill: () => {
    const body = document.querySelector('body')
    const polyfill = document.getElementById('polyfill')
    body.removeChild(polyfill)
  },

  addObjectFindPolyfill: () => {
    if (!Array.prototype.find) {
      return Object.defineProperty(Array.prototype, 'find', {
        value: function(predicate) {
          // 1. Let O be ? ToObject(this value).
          if (this == null) {
            throw new TypeError('"this" is null or not defined')
          }

          var o = Object(this)

          // 2. Let len be ? ToLength(? Get(O, "length")).
          var len = o.length >>> 0

          // 3. If IsCallable(predicate) is false, throw a TypeError exception.
          if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function')
          }

          // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
          var thisArg = arguments[1]

          // 5. Let k be 0.
          var k = 0

          // 6. Repeat, while k < len
          while (k < len) {
            // a. Let Pk be ! ToString(k).
            // b. Let kValue be ? Get(O, Pk).
            // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
            // d. If testResult is true, return kValue.
            var kValue = o[k]
            if (predicate.call(thisArg, kValue, k, o)) {
              return kValue
            }
            // e. Increase k by 1.
            k++
          }

          // 7. Return undefined.
          return undefined
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/browser-detect.js